import { useCallback } from "react";
import useAuthToken from "./useAuthToken";
import { get_middleware_bff, post_middleware_bff }from "services/middleware_services";
import { API_ENDPOINTS, type CourierFiltersPayload, type CourierServiceResponse } from "../lib/types";
import { FilterValues } from "../components/courier-dashboard/types";

export function useApiServices() {
  const token = useAuthToken();

  const fetchFilters = useCallback(async (): Promise<CourierFiltersPayload> => {
    if (!token) {
      throw new Error("No token available");
    }
    const resp = await get_middleware_bff<CourierFiltersPayload>(API_ENDPOINTS.courier_filters, token);
    return resp.data.message;
  }, [token]);

  const fetchCourierService = useCallback(async (filters: FilterValues): Promise<CourierServiceResponse> => {
    if (!token) {
      throw new Error("No token available");
    }
    const response = await post_middleware_bff<CourierServiceResponse>(API_ENDPOINTS.courier_service, filters, token);
    return response.data.message;
  }, [token]);

  return {
    fetchFilters,
    fetchCourierService
  };
}